import { Col, Grid, GridProps, ResponsiveValue, Size } from '@gousto-internal/citrus-react';
import { ReactNode } from 'react';

const DEFAULT_CARD_COLUMN_SIZES: ResponsiveValue<Size> = [12, 6, 6, 4];

export function MenuGrid({
  children,
  ...restGridProps
}: Omit<GridProps, 'gap' | 'paddingH' | 'paddingV' | 'role'>) {
  return (
    <Grid gap={[4, 4, 6]} paddingH={[4, 4, 6]} paddingV={[4, 4, 6]} role="grid" {...restGridProps}>
      {children}
    </Grid>
  );
}

export function MenuGridItem({
  children,
  cardColSizes = DEFAULT_CARD_COLUMN_SIZES,
}: {
  children: ReactNode;
  cardColSizes?: ResponsiveValue<Size>;
}) {
  return (
    <Col role="gridcell" size={cardColSizes}>
      {children}
    </Col>
  );
}
